// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__U8jDP","footerImage":"styles_footerImage__4GLIE","footerText":"styles_footerText__ZfHd3","customFontSize":"styles_customFontSize__vu11x"};